import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { TemplatesPage } from '@/routes/templates/page'

export const Templates = () => {
  return (
    <PageErrorBoundary>
      <TemplatesPage />
    </PageErrorBoundary>
  )
}
